module.exports = __webpack_public_path__ + "media/images/top-12-a3b75b7940f327f578ac8817fc777ec7.png";